export default __webpack_public_path__ + "images/powered_by_google_on_white_hdpi.png";